(() => {
  // app/scripts/common/function/compare.js
  function Compare(value) {
    const key = value;
    const { sessionStorage } = theme;
    const Storage = sessionStorage(key);
    const Compare2 = {
      get: () => {
        const data = Storage.get();
        return data ? data.split(",") : [];
      },
      set: (value2) => {
        Storage.set(value2);
        Compare2.dispatchEvent();
      },
      addItem: (value2) => {
        let data = Compare2.get();
        data = data.filter((item) => item != value2);
        data.push(value2);
        Storage.set(data.join(","));
        Compare2.dispatchEvent();
      },
      removeItem: (value2) => {
        let data = Compare2.get();
        data = data.filter((item) => item != value2);
        Storage.set(data);
        Compare2.dispatchEvent();
      },
      clearAll: () => {
        Storage.clearAll();
        Compare2.dispatchEvent();
      },
      dispatchEvent: () => {
        window.dispatchEvent(new CustomEvent(`compare:change`));
      }
    };
    return Compare2;
  }

  // app/scripts/compare-popup.js
  var { settings: { compareSection, compareKey, compareClass }, routes: { rootUrl } } = theme;
  (() => {
    let compareObj = Compare(compareKey);
    const data = compareObj.get();
    document.querySelector(".compare-number").innerHTML = data.length;
  })();
  function loadPopupCompare() {
    console.log("testing righw now");
    const compareObj = Compare(compareKey);
    const compareData = compareObj.get();
    compareData.length && fetch(`${rootUrl}?section_id=${compareSection}`).then((e) => e.text()).then((e) => {
      document.body.insertAdjacentHTML("beforeend", e.split("<!-- split -->")[1]);
    });
  }
  window.addEventListener(`compare:change`, (e) => {
    console.log("testing right now");
    !document.querySelector("compare-component") && loadPopupCompare();
  });
  customElements.define("compare-button", class extends HTMLElement {
    constructor() {
      super();
      this.handle = this.dataset.handle;
      this.Compare = Compare(compareKey);
      this.updateState();
      this.addEventListener("click", this.onClick.bind(this));
      window.addEventListener(`compare:change`, (e) => {
        this.updateState();
      });
      this.checkClass();
    }
    updateState() {
      this.setActive = this.Compare.get().includes(this.handle);
      const data = this.Compare.get();
      document.querySelector(".compare-number").innerHTML = data.length;
    }
    set setActive(value) {
      this.classList.toggle(compareClass, value);
    }
    checkClass() {
      const { Compare: Compare2, handle: value } = this;
      const data = Compare2.get();
      if (data.includes(value)) {
        this.setActive = true;
      }
    }
    onClick() {
      const { Compare: Compare2, handle: value } = this;
      const data = Compare2.get();
      if (data.includes(value)) {
        Compare2.removeItem(value);
        this.setActive = false;
        return;
      }
      if (data.length == 4) {
        alert("Compare Full");
        return;
      }
      Compare2.addItem(value);
      this.setActive = true;
    }
  });
  customElements.define("compare-component", class extends HTMLElement {
    constructor() {
      super();
      this.detailLayoutName = "compare-detail-component";
      this.defaultLayout = this.querySelector(".jsResult").innerHTML;
      this.Compare = Compare(compareKey);
      this.initialize();
      this.addEventListener("click", ({ target }) => {
        target.closest(".jsCompareToggle") && this.popupToggle();
        target.closest(".jsCompareRemove") && this.clearItem(target);
        target.closest(".jsCompareClearAll") && this.clearAll();
      });
      window.addEventListener(`compare:change`, (e) => {
        this.initialize();
      });
    }
    get getStoreData() {
      const limit = +this.dataset.limit || 4;
      const data = this.Compare.get();
      if (data.length > limit) {
        data.reverse();
        data.length = limit;
        data.reverse();
        this.Compare.set(data);
      }
      return data;
    }
    initialize() {
      const data = this.getStoreData;
      if (!data.length) {
        this.toggle = false;
        return;
      }
      this.getData(data);
    }
    clearItem(target) {
      const value = target.closest("[data-handle]").dataset.handle;
      this.Compare.removeItem(value);
    }
    clearAll() {
      this.Compare.clearAll();
      this.toggle = false;
    }
    async getData(array) {
      const promiseArr = [];
      array.forEach((handle) => {
        promiseArr.push(this.getProduct(handle));
      });
      console.log("promiseArr", promiseArr);
      Promise.all(promiseArr).then((html) => {
        const miniLayout = html.map((item) => item.split("<!-- /// -->")[0]);
        const detailLayout = html.map((item) => [item.split("<!-- /// -->")[1], item.split("<!-- /// -->")[2]]);
        this.setData = miniLayout;
        document.querySelector(this.detailLayoutName).setData = detailLayout;
        this.toggle = true;
      });
      this.querySelectorAll(".jsCompareToggle").forEach((button) => {
        button.toggleAttribute("disabled", array.length < 2);
      });
    }
    getProduct(handle) {
      const { productUrl } = this.dataset;
      const url = productUrl.replace("productHandle", handle);
      console.log("url", url);
      return new Promise((resolved, rejected) => {
        fetch(url).then((e) => e.text()).then((e) => resolved(e.split("<!-- split -->")[1]));
      });
    }
    set setData(values) {
      this.resetLayout();
      this.querySelectorAll(".jsCompareItem").forEach((item, index) => {
        const html = values[index];
        if (!html)
          return;
        const div = document.createElement("div");
        div.innerHTML = html;
        item.replaceWith(div.firstElementChild);
      });
    }
    resetLayout() {
      this.querySelector(".jsResult").innerHTML = this.defaultLayout;
    }
    popupToggle() {
      this.toggle = false;
      const comparePopup = document.querySelector(this.detailLayoutName);
      comparePopup.closest("popup-component").open();
    }
    set toggle(value) {
      if (value)
        this.closest("popup-component").open();
      else
        this.closest("popup-component").close();
    }
  });
  customElements.define("compare-detail-component", class extends HTMLElement {
    constructor() {
      super();
      this.defaultLayout = this.querySelector(".jsResultItems").innerHTML;
      this.defaultFeaturesLayout = this.querySelector(".jsResultItemsFeatures").innerHTML;
      this.Compare = Compare(compareKey);
      this.body = this.querySelector(".compare-body");
      this.loading = this.querySelector(".loading_svg");
      this.notify = this.querySelector(".compare-notify");
      if (this.Compare.get().length > 0) {
        console.log("no empty");
        this.loading.classList.add("none");
        this.body.classList.remove("none");
      } else {
        console.log("empty");
        this.loading.classList.add("none");
        this.notify.classList.remove("none");
      }
      this.addEventListener("click", ({ target }) => {
        target.closest(".jsCompareToggle") && this.popupToggle();
        target.closest(".jsCompareRemove") && this.clearItem(target);
        target.closest(".jsCompareClearAll") && this.clearAll();
        target.closest(".card-details") && this.toggleDetails(target.closest("details"));
      });
      this.addEventListener("touchmove", this.onTouch.bind(this));
    }
    // connectedCallback(){
    //     console.log('testing')
    //     this.defaultLayout = this.querySelector('.jsResultItems').innerHTML;
    //     this.defaultFeaturesLayout = this.querySelector('.jsResultItemsFeatures').innerHTML;
    //     this.Compare = Compare(compareKey);
    //     this.addEventListener('click', ({target})=>{
    //         target.closest('.jsCompareToggle') && this.popupToggle();
    //         target.closest('.jsCompareRemove') && this.clearItem(target);
    //         target.closest('.jsCompareClearAll') && this.clearAll();
    //         target.closest('.card-details') && this.toggleDetails(target.closest('details'));
    //     });
    //     this.addEventListener('touchmove', this.onTouch.bind(this))
    //     // this.querySelector('#compareHideSimilar').addEventListener('change', this.hideSimilar.bind(this));
    // }
    popupToggle() {
      const comparePopup = document.querySelector("compare-component");
      this.closest("popup-component").close();
      comparePopup.closest("popup-component").open();
    }
    clearItem(target) {
      const value = target.closest("[data-handle]").dataset.handle;
      this.Compare.removeItem(value);
      if (this.Compare.get().length)
        return;
      this.toggle = false;
      this.resetLayout();
    }
    resetLayout() {
      this.querySelector(".jsResultItems").innerHTML = this.defaultLayout;
      this.querySelector(".jsResultItemsFeatures").innerHTML = this.defaultFeaturesLayout;
    }
    set setData(values) {
      this.resetLayout();
      const compareItems = this.querySelectorAll(".jsCompareItem");
      compareItems.forEach((item, index) => {
        if (!values[index]) {
          item.remove();
          return;
        }
        const itemLayout = values[index][0];
        const featuresLayout = values[index][1];
        const divItem = document.createElement("div");
        divItem.innerHTML = itemLayout;
        compareItems[index].replaceWith(divItem.firstElementChild);
        const featuresList = document.createElement("div");
        featuresList.innerHTML = featuresLayout;
        featuresList.querySelectorAll(".jsCompareFeatures").forEach((item2) => {
          const currentLine = this.querySelector(`.jsCompareFeatures[data-index="${index}"][data-key="${item2.dataset.key}"]`);
          if (currentLine != null) {
            currentLine.innerHTML = item2.innerHTML;
            currentLine.classList.add("filled");
          }
        });
      });
      this.querySelectorAll("compare-group-feature").forEach((item) => item.update());
    }
    toggleDetails(currentTarget) {
      setTimeout(() => {
        const isOpen = currentTarget.open;
        this.querySelectorAll(".card-details details").forEach((item) => {
          item.open = isOpen;
        });
      }, 50);
    }
    onTouch() {
      const { left } = this.querySelector(".compare-table-details").getBoundingClientRect();
      if (left < 0 && this.lastPos != left) {
        this.classList.add("scrolling");
        this.lastPos = left;
        return;
      }
      left >= 0 && this.classList.remove("scrolling");
    }
    hideSimilar(event) {
      const { target } = event;
      this.querySelectorAll("compare-group-feature").forEach((item) => {
        item.hideSimilar = target.checked;
      });
    }
  });
  customElements.define("compare-group-feature", class extends HTMLElement {
    update() {
      this.querySelectorAll("compare-line-feature").forEach((item) => {
        item.checkEmpty();
      });
      this.toggleGroup();
    }
    set hideSimilar(value) {
      this.querySelectorAll("compare-line-feature:not(.hidden)").forEach((item) => {
        item.hideSimilar = value;
      });
      this.toggleGroup();
    }
    toggleGroup() {
      setTimeout(() => {
        const isHidden = this.querySelector(".jsCompareGroupFeature").scrollHeight <= 0;
        this.style.maxHeight = isHidden ? 0 : null;
        this.style.overflow = isHidden ? "hidden" : null;
      }, 50);
    }
  });
  customElements.define("compare-line-feature", class extends HTMLElement {
    checkEmpty() {
      const isHasContent = this.querySelector(".jsCompareFeatureValues").textContent.trim().length;
      this.classList.toggle("hidden", !isHasContent);
    }
    set hideSimilar(value) {
      if (!value) {
        this.classList.remove("hide-similar");
        return;
      }
      let arrayValues = [...this.querySelectorAll(".jsCompareFeatures.filled")].map((item) => item.textContent.trim());
      arrayValues = [...new Set(arrayValues)];
      arrayValues.length == 1 && this.classList.add("hide-similar");
    }
  });
})();
